import { useAtomValue, useSetAtom } from 'jotai/react';
import { IAnswer, IComponent } from '../interfaces';
import atoms from '../atoms';

interface IUseProps<T> {
  id: string;
  initial_state?: T;
}

interface IUsePropsReturn<T extends IComponent> {
  props: T;
  validate: (id: string) => void;
  addAnswer: (answer: Omit<IAnswer, 'componentID'>) => void;
  setProps: (new_props: Partial<IComponent>) => void;
}

export function useProps<T extends IComponent>({
  id,
  initial_state,
}: IUseProps<T['answer']>): IUsePropsReturn<T> {
  const components = useAtomValue<IComponent[]>(atoms.component.list);
  const setAnswerAtom = useSetAtom(atoms.answers.add);
  const setPropsAtom = useSetAtom(atoms.component.set_props);
  const position = components.findIndex((c) => c.id === id);
  const props = {
    ...components[position],
    value: components[position]?.value ?? initial_state,
  } as T; // <-- I hate typescript
  const validate = useSetAtom(atoms.actions[props?.action ?? ''].validate);
  const addAnswer = (answer: Omit<IAnswer, 'componentID'>) => {
    setAnswerAtom({ componentID: id, ...answer });
  };
  const setProps = (props: Partial<IComponent>) => {
    setPropsAtom(id, props);
  };
  return { props, validate, addAnswer, setProps };
}
